
import {defineComponent} from 'vue'
import {mapActions as mapActionsP, mapState} from "pinia";
import {useCustomerStore} from "@/stores/CustomerStore";
import InputNumber from "@/components/UI/InputNumber.vue";
import InputText from "@/components/UI/InputText.vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import BaseSpinner from "@/components/UI/Bootstrap/BaseSpinner.vue";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import SelectBrands from "@/components/layouts/catalog/SelectBrands.vue";
import {PimProductsPagingModel} from "@/models/paging/PimProductsPagingModel";
import {CustomerContext} from "@/context/CustomerContext";
import SelectCategories from "@/components/layouts/catalog/SelectCategories.vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";
import SelectTrademarks from "@/components/layouts/catalog/SelectTrademarks.vue";
import InputRadioBoolean from "@/components/UI/InputRadioBoolean.vue";
import {CatalogProductsCriteriaBodyRestDtoModel} from "@/models/criteria/CatalogProductsCriteriaBodyRestDtoModel";
import {AuthContext} from "@/context/AuthContext";
import {AbilityContext} from "@/context/AbilityContext";

export default defineComponent({
  name: "CatalogProductsOverviewCriteria",
  emits: ['reloadedContent', 'submit', 'criteriaChanged'],
  components: {
    InputRadioBoolean,
    SelectTrademarks,
    InputCheckboxBoolean, SelectCategories,
    SelectBrands,
    BaseSpinner, AlertError2, InputText, InputNumber
  },
  data() {
    return {
      catalogCustomerCode: CustomerContext.getCustomerCode(),

      criteriaUI: UIStateDto.createWithDefaults(),
    }
  },
  mounted() {
    this.reloadContent();
  },
  computed: {
    ...mapState(useCustomerStore, ["getCriteria", "getPaging", "getPimState"]),
    productsCriteria(): CatalogProductsCriteriaBodyRestDtoModel {
      return this.getCriteria.catalog_products;
    },
    cnkCodeSingleValue(): number | null {
      // Get the first value from the array or null
      return this.productsCriteria.filter_cnk_codes && this.productsCriteria.filter_cnk_codes.length > 0
        ? Number(this.productsCriteria.filter_cnk_codes[0])
        : null;
    },
    productsCriteriaIsChanged(): boolean {
      return this.getPimState.catalog_products_criteria_is_changed;
    },
    productsPaging(): PimProductsPagingModel {
      return this.getPaging.pim_products;
    },
    AuthContext() {
      return AuthContext;
    },
    AbilityContext() {
      return AbilityContext;
    }
  },
  methods: {
    ...mapActionsP(useCustomerStore, ["clearCatalogProductsCriteria"]),
    ...mapActionsP(useCustomerStore, ["searchAllBrandsCustomer"]),
    updateCnkCode(value: number | null): void {
      // Update the array with the single value or empty array if null
      this.productsCriteria.filter_cnk_codes = value !== null ? [String(value)] : null;
      this.onCriteriaChanged();
    },
    clearCriteria(): void {
      this.clearCatalogProductsCriteria();

      this.onCriteriaChanged();
    },
    onCriteriaChanged(): void {
      this.getPimState.catalog_products_criteria_is_changed = true;
      this.$emit('criteriaChanged', true);
    },
    setLaboCode(laboCode?: string | null): void {
      this.productsCriteria.filter_labo_code = laboCode;
      this.onCriteriaChanged();
    },
    setTrademarkCode(trademarkCode?: string | null): void {
      this.productsCriteria.filter_trademark_code = trademarkCode;
      this.onCriteriaChanged();
    },
    setCategoryCodeDpManaged(categoryCode?: string | null): void {
      this.productsCriteria.filter_category_code = categoryCode;
      this.onCriteriaChanged();
    },
    async reloadContent(): Promise<void> {
      this.criteriaUI
        .setNotReady()
        .clearError();

      try {
        await Promise.all([
           this.searchAllBrandsCustomer(),
         ]);

        this.getPimState.catalog_products_criteria_is_changed = false;
        this.$emit('criteriaChanged', false);
        this.$emit('reloadedContent');
      } catch (exceptions: unknown) {
        ErrorHandlerQueue
          .create()
          .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.criteriaUI as UIStateDto))
          .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.criteriaUI as UIStateDto))
          .catch(exceptions, true);
      } finally {
        this.criteriaUI.setReady();
      }
    },
    submitData(): void {
      if (this.getPimState.catalog_products_criteria_is_changed) {
        this.productsPaging.number = 1;
      }

      this.getPimState.catalog_products_criteria_is_changed = false;
      this.$emit('criteriaChanged', false);
      this.$emit('submit');
    },
  }
})
